module.exports = __webpack_public_path__ + "img/1 (103).46b7304f.png";